import LinearProgress from '@mui/material/LinearProgress';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import React from 'react';

function LinearProgressWithLabel(props) {
	let visible = props.value >= 0 && props.value <= 100;

	return (
		<Box sx={{ display: visible ? 'flex' : 'none', alignItems: 'center' }}>
			<Box sx={{ width: '100%', mr: 1 }}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography variant="body2" color="primary">{props.value}%</Typography>
			</Box>
		</Box>
	);
}

function ProgDialog(props) {
	const {caption, isOpen, prog, msg, handleClose, errmsg} = props;

// 	console.log('ProgDialog', prog);

	return (
        	<Dialog aria-labelledby="prog-dialog" open={isOpen ? true : false}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{caption}</Typography>
						{errmsg && errmsg.length > 0 ? 
							<IconButton 
							    edge="start" 
							    color="inherit" 
							    onClick={() => handleClose(false)} 
							    aria-label="close">
								<CloseIcon />
							</IconButton> : 
						null}
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'}>
					<Typography variant="subtitle1" display="inline">
						{msg && msg.length ? msg : ''}
					</Typography>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Typography variant="subtitle1" display="inline" color="secondary">
						{errmsg && errmsg.length ? errmsg : ''}
					</Typography>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<LinearProgressWithLabel value={prog} />
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default ProgDialog;
